import { useNavigate } from "react-router-dom";

export default function PagoPendiente() {

  const navigate = useNavigate();

  return (
    <div className="modal-backdrop">
      <div className="modal">

        <p>
          ⏳ Pago en proceso{"\n\n"}
          Tu pago está siendo verificado.\n
          Los puntos se acreditarán automáticamente cuando se confirme.
        </p>

        <div className="modal-actions">
          <button
            className="card-btn card-btn-primary glow-btn"
            onClick={() => navigate("/")}
          >
            Volver al inicio
          </button>
        </div>

      </div>
    </div>
  );
}